class AlgoliaIconFilter extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      defaultIconFilterUrl: this.getAttribute('default-icon-filter-url'),
      iconFilterSize: this.getAttribute('icon-filter-size'),
      iconFilterUrl: this.getAttribute('icon-filter-url')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
      .icon-filter {
        background-image: url(${this.settings.iconFilterUrl ? this.settings.iconFilterUrl : this.settings.defaultIconFilterUrl});
        background-position: center;
        background-repeat: no-repeat;
        background-size: ${this.settings.iconFilterSize}%;
        height: 100%;
        width: 100%;
      }
    `;

    return style;
  }

  /**
   * Renders the icon content.
   * @returns {string} The rendered icon.
   */
  render() {
    const style = this.getStyle();
    const div = document.createElement('div');
    div.classList.add('icon-filter');
    div.setAttribute('aria-hidden', 'true');
    div.setAttribute('focusable', 'false');
    div.textContent = ' ';
    return div;
  }
}

customElements.define("algolia-icon-filter", AlgoliaIconFilter);